{
    "confirm": {
        "confirmToDeleteMediaAndRemoveFromProjects": "Eliminar y suprimir del proyecto | Eliminar y suprimir de los proyectos",
        "unsavedChanges": "¡Cambios sin guardar!",
        "areYouSureYouWantToRemovePage": "Eliminar '{pageName}'.",
        "deleteStyle": "¿Eliminar estilo?",
        "deleteMedia": "¿Eliminar contenido multimedia?",
        "deleteMediaImplications": "¿Quiere eliminar y suprimir de proyectos?",
        "deletePlayer": "¿Eliminar reproductor?",
        "deletePlayerImplications": "Esta acción suprimirá el reproductor de su cuenta de ARYA y eliminará toda la configuración relacionada con este reproductor, incluidas las programaciones.",
        "permanentlyDeleteTheUserAccount": "Elimine la cuenta.",
        "removeTemplate": "Suprimir plantilla",
        "removeTemplateDesc": "¿Quiere suprimir esta plantilla de este estilo?",
        "removeTheMediaFromTheSchedule": "Elimine de la programación.",
        "mediaNamesIsInUploadStateAndWillPermanentlyDelete": "Elimine contenido multimedia.",
        "mediaUsedInProject": "Contenido multimedia usado en el proyecto | Contenido multimedia usado en los proyectos",
        "confirmPassword": "Confirmar contraseña",
        "changeEmail": "Cambiar correo electrónico",
        "deleteOrder": "Eliminar pedido",
        "deleteTag": "¿Eliminar etiqueta?",
        "deletePopId": "¿Eliminar ID de PoP?",
        "deleteUser": "¿Eliminar usuario?",
        "deleteAccount": "¿Eliminar cuenta?",
        "leaveAccount": "¿Abandonar la cuenta?",
        "deleteCanvasResolution": "¿Eliminar resolución de lienzo?",
        "downloadLicense": "¿Descargar licencia?",
        "cancelOrder": "¿Cancelar pedido?",
        "removeAccessFromArya": "¿Eliminar acceso de ARYA?",
        "deleteTemplate": "¿Eliminar plantilla?"
    },
    "signinup": {
        "new": "¿Es nuevo en {productNameShort}?",
        "newUser": "Nuevo usuario"
    },
    "label": {
        "aryaAccountID": "ID de cuenta de Arya",
        "accountId": "ID de cuenta",
        "admin": "administrador",
        "addPlayer": "Añadir reproductor",
        "assignCodeHasAlreadyBeenAssignedInAnotherAccountErrorMessage": "El código {code} ya se ha asignado a otra cuenta.",
        "assignCodeHasAlreadyBeenAssignedErrorMessage": "El código {code} ya se ha asignado.",
        "account": "Cuenta | Cuentas",
        "accountInfo": "Información de la cuenta",
        "accountInformation": "Información de la cuenta",
        "accountName": "Nombre de la cuenta",
        "accountPlan": "Plan de la cuenta",
        "accountCorrespondent": "Corresponsal de la cuenta",
        "accountIsDeleted": "La cuenta se ha eliminado",
        "activate": "activar",
        "address": "dirección",
        "alert": "alerta | alertas",
        "amount": "importe",
        "apply": "aplicar",
        "assign": "asignación | asignaciones",
        "audio": "audio",
        "auto": "automático",
        "basic": "básico",
        "bannerText1": "Mantenimiento programado",
        "bannerText2": "Llevaremos a cabo un mantenimiento programado el {date} a las {time} durante aproximadamente{approximateHours} horas. Sentimos las molestias que podamos causar durante este tiempo.",
        "bannerText3": "Durante el mantenimiento, {productName} no estará disponible para modificaciones de contenido, pero los reproductores podrán seguir mostrando su contenido.",
        "billing": "facturación",
        "billingDetails": "Información de facturación",
        "buy": "comprar",
        "comment": "comentario",
        "companyInformation": "Información de la empresa",
        "contentNotSupported": "contenido no compatible, haga clic para obtener más información…",
        "copy": "copia | copias",
        "configPending": "CONFIGURACIÓN PENDIENTE",
        "configError": "ERROR DE CONFIGURACIÓN",
        "credentials": "credenciales",
        "credentialsNotValid": "Credenciales no válidas",
        "createStyle": "Crear estilo",
        "createUserExistErrorMessage": "{email} ya es miembro de esta cuenta.",
        "createUserLimitReached": "Límite del usuario alcanzado",
        "creditCard": "Tarjeta de crédito",
        "download": "Descargar",
        "extended": "ampliado",
        "expirationDate": "Fecha de caducidad",
        "expires": "caduca",
        "keyboardShortcuts": "Atajos de teclado",
        "language": "Idioma",
        "learnMore": "más información",
        "leaveAccount": "Salir de la cuenta",
        "leaveAccountWithOnlyOneUserMessage": "No puede salir de la cuenta ya que es el único usuario de esta.",
        "leaveAccountTheOnlyAdminInTheAccountMessage": "No puede salir de la cuenta ya que es el único administrador de esta.",
        "leaveAccountImplicationsCommonMessage": "Esta acción le suprimirá de esta cuenta.",
        "license": "licencia",
        "limited": "limitado",
        "location": "Ubicación",
        "login": "Iniciar sesión",
        "loginError": "Algo no ha ido bien, no se ha podido iniciar la sesión en estos momentos. Vuélvalo a intentar más tarde o póngase en contacto con el administrador",
        "loginWith": "Iniciar sesión con",
        "loginString2": "Contenido en la pantalla a la vez. Gratis.",
        "loginString3": "Donde la sencillez y la señalización digital confluyen.",
        "loginString4": "Ordena y activa conjuntos de funciones sin problemas",
        "loginOKStringTitle2": "Donde la sencillez y la sincronización inteligente confluyen.",
        "loginOKStringDesc1": "Personalícelo. Prográmelo. Dele prioridad.",
        "loginOKStringDesc2": "Etiquételo. Sincronícelo de forma inteligente. Ponga alertas en caso necesario.",
        "loginOKString4": "Siguiente paso. Configuración rápida del reproductor.",
        "loginOKString5": "Lo único que necesita es el número de serie del reproductor.",
        "loginOKQuotaWarnMain": "El {percentage}% del almacenamiento gratuito está completo.",
        "loginOKQuotaWarnSub": "Actualice al plan {plan} para obtener plantillas y alertas totalmente personalizables, 10 GB de almacenamiento por reproductor, 10 usuarios, etiquetas y sincronización inteligente de etiquetas, y mucho más.",
        "loginOKQuotaReachedMain": "El {percentage}% del almacenamiento gratuito está completo.",
        "loginOKQuotaReachedSub": "Actualice al plan {plan} para obtener plantillas y alertas totalmente personalizables, 10 GB de almacenamiento por reproductor, 10 usuarios, etiquetas y sincronización inteligente de etiquetas, y mucho más.",
        "loginOKQuotaExcededMain": "Almacenamiento gratuito completo.",
        "loginOKQuotaExcededSub": "Actualice al plan {plan} para obtener plantillas y alertas totalmente personalizables, 10 GB de almacenamiento por reproductor, 10 usuarios, etiquetas y sincronización inteligente de etiquetas, y mucho más.",
        "logoutOKStringTitle1": "HA CERRADO LA SESIÓN",
        "logoutOKStringDesc1": "Para volver a iniciar sesión, haga clic en el siguiente botón.",
        "notice": "aviso",
        "playerSetupString1": "Cree su proyecto.",
        "playerSetupString2": "Es muy sencillo. Es muy rápido.",
        "playerSetupString3": "",
        "payments": "pagos",
        "pageNotFound": "Página no encontrada, lo sentimos",
        "plan": "plan | planes",
        "popIdentifier": "IDENTIFICADOR PoP",
        "postalCode": "Código postal",
        "purchasePlanUpgradeSuccessMain": "Le damos la bienvenida a {plan}",
        "purchasePlanDowngradeSuccessMain": "La cuenta ha cambiado al plan {planName}",
        "loggedOffInFewSeconds": "En unos segundos se cerrará su sesión",
        "termsOfServiceString1": "Condiciones del servicio",
        "termsOfServiceString2": "Última actualización: 9 de enero de 2019",
        "termsOfServiceString3": "Descargue y lea el siguiente documento",
        "termsOfServiceString4": "CONDICIONES DEL SERVICIO",
        "termsOfServiceString5": "POLÍTICA DE PRIVACIDAD",
        "termsOfServiceString6": "Seleccione ACEPTAR para continuar.",
        "accept": "aceptar",
        "all": "Todo",
        "allPlayers": "Todos los reproductores",
        "add": "Añadir",
        "setPassword": "Confirmar",
        "support": "soporte técnico",
        "cancel": "cancelar",
        "canvasSize": "Tamaño del lienzo: {size} píxeles",
        "canvasExistsError": "Ya existe un lienzo con este tamaño",
        "cardType": "tipo de tarjeta",
        "cardNumber": "número de tarjeta",
        "change": "cambiar",
        "clickToEdit": "hacer clic para editar",
        "city": "ciudad",
        "color": "color | colores",
        "company": "empresa",
        "companyName": "Nombre de la empresa",
        "confirm": "Confirmar",
        "confirmation": "Confirmación",
        "warning": "Advertencia",
        "codeIsRequired": "Código de verificación requerido",
        "code": "Código",
        "contact": "contacto",
        "country": "país",
        "create": "Crear",
        "checkThePlayer": "Conéctese a Internet. Conecte la fuente de alimentación.",
        "checkDetails": "Comprobar detalles",
        "chooseHorizontalOrVerticalScreenOrientations": "Elegir la orientación de la pantalla",
        "continue": "Continuar",
        "conctactSystemAdmin": "Póngase en contacto con el administrador del sistema.",
        "custom": "personalizar",
        "customerInfo": "Información del cliente",
        "date": "fecha",
        "dropFilesHere": "Colocar archivos aquí",
        "deactivate": "desactivar",
        "default": "predeterminado",
        "delete": "eliminar",
        "deleteAccount": "eliminar cuenta",
        "deleteUser": "eliminar usuario",
        "deleteOnAllPlayers": "ELIMÍNELO en TODOS LOS REPRODUCTORES.",
        "deleteFromSchedule": "Eliminar de la programación",
        "demoVersion": "Versión de demostración",
        "disable": "deshabilitar",
        "disabled": "deshabilitado",
        "distributor": "distribuidor",
        "downgradeAccount": "Cambiar la cuenta de plan",
        "downgradeTo": "Cambiar a {plan}",
        "duplicate": "Duplicar",
        "duplicateFile": "Duplicar archivo",
        "duplicateInSchedule": "Duplicar en la programación",
        "duration": "Duración",
        "adsDuration": "Duración de anuncios",
        "error": "error",
        "email": "correo electrónico",
        "emailAlreadyExists": "La nueva dirección de correo electrónico ya la está usando otro usuario. Utilice una distinta.",
        "enable": "habilitar",
        "enabled": "habilitado",
        "endDate": "Finalizar",
        "endTime": "Finalizar",
        "end": "finalizar",
        "edit": "Editar",
        "editProject": "Editar proyecto",
        "feedbackForm": "Dejar comentarios",
        "firstName": "Nombre",
        "firmwareUpdate": "ACTUALIZACIÓN DEL FIRMWARE",
        "failed": "Contactar con soporte técnico",
        "file": "Archivo | Archivos",
        "forgotPassword": "¿Ha olvidado la contraseña?",
        "formatNotSupported": "Los archivos «{format}» no son compatibles.",
        "firmware": "Firmware",
        "freeVersion": "Versión gratuita",
        "freeVersionNA": "Versión gratuita N/D",
        "get": "obtener",
        "getCode": "Obtener configuración",
        "getConfig": "Obtener configuración",
        "generateNewAPIKey": "Generar una nueva clave de API",
        "generateUserAPIKeyWarningMessage": "Esta acción hará que la anterior clave de API sea no válida; cualquier conexión existente a la API se tendrá que volver a configurar para usar la nueva clave de API.",
        "goBack": "Volver",
        "goToLogin": "Ir al inicio de sesión",
        "helpCenter": "Centro de ayuda",
        "horizontalView": "Vista horizontal",
        "image": "Imagen | Imágenes",
        "implications": "implicaciones",
        "implicationsDeleteTag": "Esta acción eliminará esta etiqueta de todos los {deleteFrom}. Esto podría afectar a los permisos del usuario y a la programación.",
        "implicationsDeleteLedTag": "Esta acción eliminará esta etiqueta de todos los reproductores. Cualquier reproductor que tuviera esta etiqueta tendrá que volver a configurarse si se le puede volver a publicar contenido con esta resolución.",
        "implicationsDeletePopId": "Esta acción eliminará este ID PoP en todos los lugares en los que se use.",
        "importantToNote": "Nota importante",
        "logo": "logotipo",
        "userProfile": "Perfil de usuario",
        "userSignOut": "Cerrar sesión",
        "userNotConfirmed": "Usuario no confirmado",
        "userNotFound": "El usuario no existe. Asegúrate de que esta cuenta existe",
        "userManagement": "Gestión de usuarios",
        "id": "id",
        "incorrectUsername": "Correo electrónico incorrecto",
        "incorrectPassword": "Contraseña incorrecta",
        "installedOrCapacity": "Instalado/Capacidad",
        "installed": "Instalado",
        "installedOrCapacityUnlimitedMaxValue": "de reproductores ilimitados",
        "invalidEmail": "Correo electrónico no válido",
        "invalidPassword": "Contraseña no válida",
        "invalidUserdata": "Contactar con soporte técnico",
        "invalidSerialNumber": "Número de serie incorrecto",
        "invalidDSOSTypeAmount": "Valor no válido, introduzca un número.",
        "invalidResolution": "Resolución no válida",
        "invoice": "factura | facturas",
        "inviteUser": "Invitar a usuario",
        "requiredDeviceName": "Nombre requerido",
        "regular": "habitual",
        "resetPassword": "Restablecer contraseña",
        "loading": "Cargando...",
        "lastName": "Apellidos",
        "lastLogin": "Último inicio de sesión",
        "modify": "modificar",
        "monitoring": "supervisando",
        "newPassword": "Nueva contraseña",
        "newPasswordRequiredWarning": "Establecer la contraseña",
        "confirmNewPassword": "Confirmar la nueva contraseña",
        "new": "Nuevo",
        "newCanvas": "Nuevo lienzo",
        "newProject": "nuevo proyecto",
        "newEmail": "Nuevo correo electrónico",
        "newResolution": "Nueva resolución",
        "name": "nombre",
        "naText": "N/D",
        "next": "siguiente",
        "nextRenewalDate": "Siguiente renovación {renewalDate}",
        "noVideoAvailable": "No hay vídeo disponible.",
        "noEmailProvided": "No se ha proporcionado un correo electrónico",
        "none": "ninguno",
        "noSearchResults": "no hay resultados",
        "noPermissionToAccessThePage": "Acceso denegado",
        "noPlayersInstalled": "No hay reproductores instalados",
        "noPlayerGroupsAvailable": "No hay grupos de reproductores disponibles",
        "notConfigured": "Configuración requerida",
        "nameYourPlayerEGReception": "Asigne un nombre a su reproductor; p. ej., Recepción",
        "ok": "vale",
        "or": "o",
        "orders": "pedidos",
        "order": "pedido | pedidos",
        "offline": "Sin conexión",
        "online": "en línea",
        "options": "opciones",
        "page": "Página",
        "player": "reproductor | reproductores",
        "playerName": "Nombre del reproductor",
        "playerModel": "Modelo del reproductor",
        "playerGroups": "Grupos de reproductores",
        "pleaseEnterACity": "Introducir ciudad",
        "pin": "PIN",
        "pinShownOnYourScreen": "PIN mostrado en la pantalla",
        "playTime": "Tiempo de reproducción",
        "PleaseTryAgainOrHeadBackToTheHomepage": "Inténtelo de nuevo o vuelva a la página inicial",
        "playerIsNotConnectedToTheCloud": "Número de serie incorrecto",
        "pleaseTryAgain": "Volver a intentarlo",
        "pleaseEnterThePin": "PIN requerido",
        "pleaseEnterValidPin": "Introduzca el número de 4 o 6 dígitos que se muestra en la pantalla",
        "pinMustBeFourDigitNumber": "El PIN debe ser un número de 4 a 6 dígitos",
        "pinMustBeAtleastOneThousand": "El PIN debe ser al menos el número 1000",
        "pleaseCheckYourEmailForVerificationCode": "Código de verificación enviado a su correo electrónico",
        "password": "contraseña",
        "passwordDidNotMatch": "Contraseña incorrecta",
        "passwordCannotBeReset": "No se puede restablecer la contraseña",
        "passwordHasBeenChanged": "Se ha cambiado la contraseña",
        "passwordAttemptLimitExceeded": "Se ha alcanzado el límite de intentos, inténtelo pasado un tiempo.",
        "passwordPolicyRequirementText": "La contraseña debe tener 8 caracteres como mínimo y tiene que incluir mayúsculas, minúsculas, números y caracteres especiales.",
        "price": "Precio",
        "priceSlashMonth": "Precio/mes",
        "priority": "prioridad",
        "privacy": "Privacidad",
        "project": "Proyecto | Proyectos",
        "projectName": "Nombre del proyecto",
        "profile": "Perfil",
        "proofOfPlay": "Prueba de reproducción",
        "preview": "Vista previa",
        "previewUnavailable": "Vista previa no disponible",
        "proceed": "continuar ",
        "publishTo": "Publicar en",
        "releaseNotes": "Notas de la versión",
        "remove": "suprimir",
        "removeUserFromAccount": "suprimir usuario de la cuenta",
        "replace": "sustituir",
        "reporting": "informes",
        "reset": "restablecer",
        "restart": "reiniciar",
        "resolution": "resolución",
        "reactivate": "reactivar",
        "resetPasswordDescription": "Introducir el correo electrónico para recibir el código de verificación",
        "resetPasswordCodeSent": "Código de verificación enviado a su correo electrónico",
        "resetPasswordCodeSentIfAccountExist": "SI LA CUENTA EXISTE",
        "requiredAccountName": "Nombre de la cuenta requerido",
        "requiredEmail": "Correo electrónico requerido",
        "requiredCountry": "País requerido",
        "requiredPassword": "Contraseña requerida",
        "requiredConfirmPassword": "Confirmar la contraseña requerida",
        "requiredFirstName": "Nombre requerido",
        "requiredLastName": "Apellidos requeridos",
        "requiredName": "Nombre requerido",
        "requiredUsername": "Correo electrónico requerido",
        "requiredVerificationCode": "Código de verificación requerido",
        "requiredSerialNumber": "Número de serie requerido",
        "requiredCity": "Ciudad requerida",
        "requiredState": "Estado requerido",
        "requiredZipOrPostalCode": "Código postal requerido",
        "requiredStreetAndNumber": "Calle y número requeridos",
        "requiredCompanyName": "Nombre de la empresa requerido",
        "requiredDataStorageRegion": "Se requiere región de almacenamiento de datos",
        "invalidDataStorageRegion": "Región de almacenamiento de datos no válida",
        "review": "revisar",
        "signOut": "cerrar sesión",
        "search": "Buscar",
        "addressSearchPlaceholder": "Escribir la dirección para localizar reproductores",
        "searching": "buscando",
        "status": "estado",
        "save": "guardar",
        "reconfigure": "Reiniciar configuración",
        "saveAs": "Guardar como",
        "saveChanges": "Guardar cambios",
        "savedStyles": "Estilos guardados",
        "schedule": "programación",
        "scheduledToTag": "Acción Para etiquetar programada",
        "screen": "pantalla",
        "screenOn": "Pantalla encendida",
        "screenOrientation": "Orientación de la pantalla",
        "security": "Seguridad",
        "sendCode": "Enviar código",
        "sendEmail": "Enviar",
        "sendInvitation": "Enviar invitación",
        "sendTo": "Enviar a",
        "serial": "Número de serie",
        "serialNumber": "Número de serie",
        "serialNumberAlreadyAssigned": "Número de serie ya asignado",
        "select": "SELECCIONAR",
        "selectAll": "seleccionar todo",
        "selectLanguage": "seleccionar idioma",
        "setup": "Configurar",
        "settings": "configuración",
        "shapeColors": "Colores de las formas",
        "shareWithText": "Señalización digital de {productShortName}. Sencillo. Inteligente. Potente.",
        "signIn": "Iniciar sesión",
        "signUp": "Registrarse",
        "signUpErrorMessageAccountEmailExist": "Ya existe una cuenta con el correo electrónico proporcionado.",
        "slowSync": "SINCRONIZACIÓN LENTA ",
        "sorry": "Lo sentimos.",
        "streetAndNumber": "Calle y número",
        "success": "correcto",
        "summary": "resumen",
        "somethingWentWrong": "Algo no ha ido bien",
        "song": "Canción | Canciones",
        "startDate": "Fecha de inicio",
        "startTime": "Iniciar",
        "start": "Iniciar",
        "state": "estado",
        "steps": "pasos",
        "styleName": "Nombre del estilo",
        "storage": "almacenamiento",
        "subtotal": "subtotal",
        "subscription": "suscripción",
        "subscriptionMonthlyAutoRenew": "Mensual (renovación automática)",
        "ssoLoginErrorTitle": "Algo no ha ido bien, no se ha podido iniciar la sesión en estos momentos. Vuélvalo a intentar más tarde o póngase en contacto con el administrador",
        "ssoMigrateAccountStep1Title1": "Ya existe una cuenta para {email}.",
        "ssoMigrateAccountStep1Title2": "Puede cambiarla para usar el SSO de {provider}.",
        "ssoMigrateAccountStep1Title3": "Continúe para confirmar el cambio.",
        "ssoMigrateAccountStep2Title1": "Cuando confirme el cambio al SSO de {provider},",
        "ssoMigrateAccountStep2Title2": "el inicio de sesión anterior ya no funcionará.",
        "ssoMigrateAccountStep2Title3": "Esta acción no se puede revertir.",
        "ssoMigrateAccountVerifyTitle1": "Tenemos que verificar su cuenta de {email} existente.",
        "ssoMigrateAccountVerifyTitle2": "Inicie sesión con esa cuenta para continuar.",
        "tag": "etiqueta | etiquetas",
        "defaultTags": "Etiquetas predeterminadas",
        "text": "texto",
        "deleteAccountWithMultipleUsersMessage": "Para poder eliminar esta cuenta tiene que suprimir el resto de usuarios.",
        "deleteAccountWithDistributorRightsMessage": "Esta cuenta no se puede eliminar. Es propiedad de un distribuidor.",
        "deleteAccountTitleThisActionWill": "Esta acción",
        "deleteAccountImplications": {
            "deleteAccount": "1. Eliminará la cuenta",
            "deleteUser": "2. Eliminará el usuario"
        },
        "youCannotDeleteUserAsOnlyUserInAccount": "No puede eliminar el usuario porque es el único usuario de la cuenta.",
        "timeZone": "Zona horaria",
        "time": "hora",
        "timeShorthandSecond": "S",
        "timeShorthandMinute": "MIN",
        "timeShorthandHour": "H",
        "template": "Plantilla | Plantillas",
        "temporaryPassword": "contraseña temporal",
        "tempPasswordExpiredPleaseContactAdmin": "La contraseña temporal ha caducado. Póngase en contacto con el administrador",
        "total": "total",
        "tutorial": "Tutorial | Tutoriales",
        "user": "usuario | usuarios",
        "userAPIKey": "Clave de API",
        "userNotActive": "Usuario no activo",
        "usernameShouldBeValidEmail": "El nombre de usuario debe tener un correo electrónico válido",
        "updatedAccountInfo": "La información de la cuenta se ha actualizado.",
        "updatedCustomerInfo": "La información del cliente se ha actualizado.",
        "updatedProfile": "El perfil de usuario se ha actualizado.",
        "updated": "actualizado",
        "upload": "Cargado",
        "upTime": "tiempo de funcionamiento",
        "upgrade": "actualizar",
        "video": "Vídeo",
        "vat": "CIF",
        "verificationCode": "Código de verificación",
        "verticalView": "Vista vertical",
        "withResolution": "con una resolución de {resolution}",
        "yourPlan": "su plan",
        "youHaveLeftAccount": "Ha salido de la cuenta",
        "zipOrPostalCode": "Código postal",
        "mon": "Lu",
        "tue": "Ma",
        "wed": "Mi",
        "thu": "Ju",
        "fri": "Vi",
        "sat": "Sa",
        "sun": "Do",
        "apps": "aplicaciones",
        "multiplePopIdsNotAllowed": "Cada archivo solo puede tener un Identificador de prueba de reproducción.",
        "forbidden": "Algo no ha ido bien y no hemos podido completar su solicitud. En breve se le redirigirá a la página inicial.",
        "dataStorageRegion": "Región de almacenamiento de datos",
        "verificationSentToEmailIfExist": "Código de verificación enviado a su correo electrónico (si la cuenta existe)",
        "alreadyHaveAnAccountRedirect": "¿Ya tienes una cuenta? {linkStart}Iniciar sesión{linkEnd}",
        "emailText": "Correo electrónico",
        "passwordText": "Contraseña",
        "signupWith": "Regístrate con",
        "setNewPassword": "Establecer contraseña",
        "passwordHint": "{minStart}Mínimo 8 caracteres,{minEnd} {upStart}mayúscula,{upEnd} {lowStart}minúscula,{lowEnd} {numStart}número{numEnd}{numSpecialSeparatorStart} y {numSpecialSeparatorEnd}{spStart}carácter especial{spEnd}.",
        "home": "Inicio",
        "loginWithName": "Iniciar sesión con {name}",
        "signupWithName": "Registrarse con {name}",
        "fileType": "Tipo de archivo",
        "lastModified": "Última modificación",
        "images": "Imágenes",
        "videos": "Vídeos",
        "projectsOrPdf": "Proyectos / PDF",
        "elementiProject": "Proyectos Elementi",
        "scheduled": "Programado",
        "notScheduled": "No programado",
        "from": "Desde",
        "to": "Hasta",
        "fileTypes": "Tipos de archivo",
        "contentStatus": "Estado del contenido",
        "modifiedDate": "Fecha de modificación",
        "filters": "Filtros",
        "sortBy": "Ordenar por",
        "sort": "Ordenar",
        "lastModifiedDesc": "Última modificación (más reciente primero)",
        "lastModifiedAsc": "Última modificación (más antiguo primero)",
        "nameAsc": "Nombre (A → Z)",
        "nameDesc": "Nombre (Z → A)",
        "grid": "Cuadrícula",
        "canvas": "Lienzo",
        "audioPlaylist": "Lista de reproducción de audio",
        "isAlertActive": "Alert activo",
        "active": "Activo",
        "inactive": "Inactivo",
        "filesPage": "Página de Archivos",
        "ledPage": "Página LED",
        "videowallPage": "Página Videowall",
        "alertPage": "Página de Alertas"
    },
    "buttons": {
        "backToProduct": "Volver a {productName}",
        "reload": "Recargar",
        "previous": "Anterior",
        "next": "Siguiente",
        "loadMore": "Cargar más",
        "addNewUser": "Añadir nuevo usuario",
        "apply": "Aplicar",
        "clearAll": "Borrar todo",
        "reset": "Restablecer",
        "tryItNow": "Pruébalo ahora",
        "switchBack": "Volver al anterior",
        "cancel": "Cancelar",
        "deleteMedia": "Eliminar medios",
        "deletePlayer": "Eliminar reproductor",
        "deleteTag": "Eliminar etiqueta",
        "deletePopId": "Eliminar ID de PoP",
        "deleteUser": "Eliminar usuario",
        "continueWithoutSaving": "Continuar sin guardar",
        "close": "Cerrar",
        "cancelOrder": "Cancelar pedido",
        "removeUser": "Eliminar usuario",
        "deleteTemplate": "Eliminar plantilla",
        "deleteStyle": "Eliminar estilo",
        "ok": "Aceptar",
        "delete": "Eliminar",
        "keepBoth": "Mantener ambos",
        "replaceExistingFile": "Reemplazar archivo existente",
        "replaceExistingFiles": "Reemplazar archivos existentes"
    },
    "texts": {
        "youAreLoggingIn": "Has iniciado sesión con",
        "productAccessDisabled": "No tienes acceso a {product}",
        "productAccessDisabledWarning": "No tienes acceso a {product} para la cuenta {account}.\n\nO no se te otorgó acceso a este producto, o tu acceso fue revocado por el Administrador Global. Por favor, contacta al Administrador Global para obtener más información o para solicitar acceso.\n\nPuedes seguir accediendo a otros productos que tienes permiso para usar dentro de esta cuenta.",
        "tablePageCountWTotal": "Mostrando {min}{separator}{max} de {total}",
        "tablePageCountWoutTotal": "Mostrando {min}{separator}{max}",
        "dataStorageRegionHint": "Elija la región donde se almacenarán los datos de su cuenta. Esta decisión debe alinearse con sus leyes locales de protección de datos y necesidades de cumplimiento. Tenga en cuenta: una vez seleccionada, la región de residencia de datos no se puede cambiar posteriormente.",
        "welcomeToHUB": "¡Bienvenido a SpinetiX HUB!",
        "welcomeToHUBDesc": "SpinetiX HUB es su plataforma en línea todo en uno para gestionar todo lo relacionado con su señalización digital SpinetiX en la nube.",
        "hubGlobalAdmin": "Administrador Global de SpinetiX",
        "hubGlobalAdminDesc": "Este usuario es un Administrador Global en el HUB, lo que le otorga automáticamente el rol de Administrador en ARYA. Esta asignación de rol no se puede modificar.",
        "removeAccessFromAryaTitle": "¿Eliminar acceso a ARYA?",
        "removeAccessFromAryaMessage": "Esto eliminará solo el acceso de {userName} a ARYA.",
        "removeAccessFromAryaByNonGlobalAdmin": "Para eliminar al usuario de la cuenta de HUB, comuníquese con su Global Admin.",
        "removeAccessFromAryaByGlobalAdmin": "Seguirá teniendo acceso a otros productos en esta cuenta de HUB.\n\nPara eliminar al usuario de la cuenta de HUB, dirígete a {link}",
        "hubUserManagement": "Gestión de usuarios de HUB",
        "goToHUBUserManagement": "vaya a la gestión de usuarios de HUB.",
        "noContentHasBeenScheduledYet": "Aún no se ha programado ningún contenido.",
        "emptyFilterTablePlaceholder": "No encontramos ningún elemento que coincida con tu búsqueda. ¡Intenta ajustar tus términos de búsqueda y vuelve a intentarlo!",
        "requestId": "ID de solicitud:",
        "externalSignInMessage": "Ha iniciado sesión con un proveedor de identidad externo (por ejemplo, Google, Facebook o SSO con otro proveedor de identidad). Sus credenciales, incluidos {email} y {password}, son gestionadas por ese proveedor.",
        "youHaveUnsavedChanges": "Tienes cambios sin guardar.",
        "waitForUploadingFile": "Subiendo archivo, por favor espera...",
        "defaultTagsNote": "Los proyectos heredan las etiquetas del Style Pack cuando se crean a partir de la plantilla. Si añades o eliminas etiquetas del Style Pack más tarde, los proyectos existentes no se actualizarán.",
        "seeAll": "Ver todo",
        "allPlayTimes": "Todos los horarios de reproducción"
    },
    "switchedAccount": {
        "title": "Cuenta cambiada",
        "desc1": "Le damos la bienvenida.",
        "switch": "cambiar",
        "text1": "Cuenta cambiada",
        "text2": "a {account}"
    },
    "unsupportedBrowser": {
        "bannerTitle": "Su navegador no es compatible",
        "bannerMessage": "Está utilizando un navegador no compatible. Puede que algunas características no funcionen correctamente. Para obtener la mejor experiencia con nuestro producto, utilice {highlightStart}Google Chrome{highlightEnd} o {highlightStart}Microsoft Edge{highlightEnd}."
    },
    "plans": {
        "downgradedToFreeDesc": "El plan {plan} ya está habilitado. Se hará un último cargo a su tarjeta de crédito al final del ciclo de facturación",
        "free": "Gratis",
        "tags": "SINCRONIZACIÓN INTELIGENTE Y ETIQUETAS",
        "sharedStorage": "almacenamiento compartido",
        "custom": "Personalizar y alertas",
        "playerStorage": "Almacenamiento del reproductor",
        "playerPerMonth": "reproductor/mes | reproductores/mes",
        "review": {
            "termsAndConditionsMain": "Al realizar el pedido, acepta las",
            "termsAndConditionsSub": "Condiciones de venta de SpinetiX"
        }
    },
    "filters": {
        "images": "imágenes",
        "videos": "vídeos",
        "audio": "audio",
        "projectsOrPdf": "proyectos/PDF",
        "scheduled": "programado",
        "elementiProject": "proyectos de elementi"
    },
    "template": {
        "24H": "24 h",
        "AM/PM": "AM/PM",
        "addPage": "Añadir página",
        "arrowSettings": "Configuración de flecha",
        "back": "Volver",
        "background": "Fondo",
        "both": "Ambos",
        "bottom": "parte inferior",
        "center": "centro",
        "cellSettings": "Configuración de la celda",
        "clock": "reloj",
        "clockSettings": "Configuración del reloj",
        "countdown": "cuenta atrás",
        "countdownSettings": "Configuración de la cuenta atrás",
        "custom": "personalizar",
        "changeMedia": "Cambiar contenido multimedia",
        "default": "predeterminado",
        "duplicatePage": "duplicar página",
        "date": "fecha",
        "days": "días",
        "effects": "Efectos",
        "fade": "Atenuar",
        "fill": "rellenar",
        "front": "Parte frontal",
        "frameFitting": "Ajuste del marco",
        "hours": "horas",
        "imageEffects": "Efectos de la imagen",
        "kenBurns": "Ken Burns",
        "noEffect": "Sin efecto",
        "noBorder": "Sin borde",
        "noMargin": "Sin margen",
        "L": "L",
        "large": "grande",
        "left": "Izquierda",
        "local": "local",
        "long": "largo",
        "M": "M",
        "meet": "satisfacer",
        "media": "contenido multimedia",
        "menu": "menú",
        "mediatable": "tabla de contenido multimedia",
        "middle": "Centro",
        "month": "mes",
        "overlay": "superponer",
        "overview": "información general",
        "playOnce": "Reproducir una vez",
        "qr": "qr",
        "reg": "reg",
        "repeat": "repetir",
        "right": "Derecha",
        "rss": "RSS",
        "shape": "forma",
        "shapeSettings": "Configuración de la forma",
        "shapeSettingsHint": "Pista: Empiece a escribir para añadir texto",
        "slice": "trocear",
        "slide": "Diapositiva",
        "small": "pequeño",
        "smart": "inteligente",
        "S": "S",
        "time": "Hora",
        "timeAndDate": "HORA + FECHA",
        "tableSettings": "Configuración de la tabla",
        "text": "texto",
        "textSettings": "Configuración del texto",
        "top": "parte superior",
        "wayfinding": "señalización",
        "weather": "tiempo",
        "html": "página web",
        "url": "url",
        "videoin": "Vídeo insertado",
        "videoWidth": "anchura del vídeo",
        "videoHeight": "altura del vídeo",
        "videoSettings": "Configuración del vídeo",
        "frameRate": "velocidad de fotogramas",
        "frameWidth": "Seleccionar anchura",
        "format": "formato",
        "error": {
            "invalidLink": "Enlace no válido"
        },
        "placeholder": {
            "url": "Introducir URL"
        },
        "weatherIconSettings": "Configuración del icono del tiempo",
        "weatherLocationSettings": "Configuración de la ubicación del tiempo",
        "weatherLocationSettingsHint": "Pista: Escribir el nombre de la ubicación",
        "webpageSettings": "Configuración de la página web",
        "qrSettings": "Configuración del QR",
        "rssSettings": "Configuración del RSS",
        "rssSettingsTooltip": "Las transmisiones de RSS que ofrece {productName} las suministran <b>proveedores externos</b>.<br>Nos esforzamos por ofrecer una selección variada de transmisiones y, de este modo, satisfacer sus necesidades; no obstante, la calidad y el rendimiento de estas dependen totalmente de estos proveedores externos.",
        "stream": "Transmisión",
        "list": "Lista"
    },
    "templates": {
        "duration": "Duración",
        "pageDuration": "Duración de la página",
        "timezone": "Zona horaria",
        "tags": "Etiquetas",
        "playtimes": "Tiempo de reproducción",
        "alignElements": "Alinear elementos",
        "removeTemplateConfirmation": "¿Estás seguro de que quieres eliminar esta plantilla del estilo \"{styleName}\"?",
        "deleteStyleConfirmation": "¿Estás seguro de que quieres eliminar el estilo \"{styleName}\"?",
        "deleteStyleWarning": "Al eliminar este estilo, se eliminarán todas las plantillas creadas en él.",
        "noTemplatesAvailable": "No hay plantillas disponibles",
        "noStylePackAccess": "Actualmente no tienes acceso a ningún paquete de estilos que contenga plantillas. Los paquetes de estilos solo están disponibles cuando se comparten contigo a través de tus permisos o etiquetas asignadas.\nSi crees que deberías tener acceso, ponte en contacto con el administrador de tu cuenta."
    },
    "Hours": {
        "title": "Título",
        "time": "Horas",
        "media": "Contenido multimedia"
    },
    "Info": {
        "info": "Información",
        "title": "Título",
        "description": "Texto",
        "media": "Contenido multimedia"
    },
    "Logo": {
        "title": "Texto"
    },
    "Menu": {
        "menu": "Menú",
        "title": "Texto",
        "price": "Precio",
        "media": "Contenido multimedia"
    },
    "News": {
        "news": "Noticias",
        "title": "Texto",
        "timezone": "Zona horaria",
        "format": "Formato",
        "media": "Contenido multimedia"
    },
    "Person": {
        "person": "Persona",
        "title": "Parte superior del texto",
        "description": "Parte inferior del texto",
        "media": "Contenido multimedia"
    },
    "Product": {
        "product": "Producto",
        "title": "Texto",
        "price": "Precio",
        "media": "Contenido multimedia"
    },
    "RSS": {
        "rss-news": "Noticias RSS",
        "rss": "RSS",
        "news": "Noticias"
    },
    "Weather": {
        "weather": "Tiempo",
        "locations": "Ciudad",
        "display": "Mostrar",
        "media": "Contenido multimedia"
    },
    "playerSetup": {
        "navConfirm": "Confirmar",
        "navFinish": "Finalizar",
        "navNext": "Siguiente",
        "navPrev": "Volver",
        "navCancel": "Cancelar",
        "addPlayerToPlan": "Añadir reproductor al plan",
        "currentPlan": "Plan actual",
        "canvasName": "Nombre del lienzo",
        "canvasVideoNote": "Encontrará su nuevo lienzo en {canvasType} bajo este nombre.",
        "canvasVideoNoteType_led": "Sección LED",
        "canvasVideoNoteType_videowall": "Sección Pared de vídeo",
        "canvasSize": "Tamaño del lienzo",
        "canvasSizeFormatted": "{canvasSize} píxeles",
        "updateTo": "Actualizado a",
        "numberOfPlayers": "Número de reproductores",
        "dialogTitle": "Configuración del reproductor",
        "onlyDigitsRequired": "Introduzca solo dígitos",
        "serialNumberRequired": "El número de serie no puede estar vacío",
        "incorrectSerialNumber": "Introduzca un número de serie correcto",
        "incorrectSerialNumberCharacters": "Introduzca una entrada válida. En este campo solo puede utilizar letras y números en español.",
        "incorrectInput": "Entrada incorrecta",
        "playerName": "Nombre",
        "playerNamePlaceholder": "Nombre del reproductor",
        "requiredPlayerName": "Se requiere el nombre del reproductor",
        "requiredScreenDiagonal": "Se requiere la diagonal de pantalla",
        "requiredHorizontalBezel": "Se requiere el bisel/espacio horizontal",
        "requiredVerticalBezel": "Se requiere el bisel/espacio vertical",
        "playerTimezoneHint": "Seleccionar la zona horaria del reproductor",
        "Progress_PIN": "PIN",
        "Progress_Name": "Nombre y zona horaria",
        "Progress_DisplaySettings": "Configuración de la pantalla",
        "Progress_Application": "Aplicación",
        "Progress_Arrangement": "Disposición",
        "Progress_Adjustments": "Ajustes",
        "DisplayOrientation": "Orientación de la pantalla",
        "DisplayResolution": "Resolución de la pantalla",
        "DisplayResolutionHint": "Seleccionar la resolución de la pantalla",
        "Application": "Aplicación",
        "ApplicationSingleDisplay": "Pantalla única",
        "ApplicationMirroring": "Duplicar",
        "ApplicationVideowall": "Pared de vídeo",
        "ApplicationAvailable": "*Disponible con",
        "ApplicationAvailbleWithNote": "*Disponible con",
        "screenDiagonal": "Diagonal de pantalla",
        "SelectApplication": "Seleccionar la aplicación",
        "SelectDisplayOrientation": "Seleccionar la orientación de la pantalla",
        "SelectNumberOfDisplays": "Seleccionar el número de pantallas",
        "standardScreenOnly": "Solo pantalla estándar (9:16 y 16:9)",
        "OrientationAndResolution": "La configuración de la orientación y la resolución se aplicará a todas las pantallas",
        "DisplaysArrangement": "Disposición de la pantalla",
        "SelectDisplayArrangement": "Seleccionar la orientación de la pantalla",
        "HorizontalBezel": "Bisel/espacio horizontal",
        "VerticalBezel": "Bisel/espacio vertical",
        "OutputResolutions": "Resoluciones de salida",
        "CannotCreateLEDTag": "No se puede crear una resolución LED",
        "CannotCreateVideowallTag": "No se puede crear un lienzo de Pared de vídeo",
        "UnknownError": "Se ha producido un error desconocido. Inténtelo de nuevo o póngase en contacto con el soporte técnico.",
        "InvalidAdjustmentsForm": "Hay errores de validación en la entrada; complete todos los campos correctamente",
        "CanvasDimensionsError": "La anchura o la altura del lienzo no se ha generado correctamente",
        "playerDeleteConfirmation": "¿Estás seguro de que quieres eliminar el reproductor: {playerName}?",
        "playerDeleteWarning": "Eliminar el reproductor lo eliminará de tu cuenta de SpinetiX HUB y borrará todas las configuraciones asociadas, incluida la programación."
    },
    "planCard": {
        "getPremium": "Pasar a Premium",
        "bestforGettingStarted": "Perfecto para empezar",
        "discovery": "Descubrimiento",
        "free": "Gratis",
        "oneUser": "1 usuario",
        "oneGBStorage": "1 GB de almacenamiento",
        "nineTemplates": "9 plantillas",
        "yourPlan": "Su plan",
        "elevateYourDigitalSignage": "Impulse su señalización digital",
        "premium": "Premium",
        "premiumPlanPrice": "21 CHF",
        "playerPerMonth": "reproductor/mes",
        "tenUsersAndRoles": "10 usuarios y roles de usuario",
        "tenGBPlayerStorage": "10 GB/almacenamiento de reproductor",
        "twelveTemplatesCustomizable": "12 plantillas/personalizables",
        "twelveApps": "12 aplicaciones, incluidas páginas web",
        "elevenApps": "11 aplicaciones",
        "assetGrouping": "Agrupación de recursos",
        "scheduleAutomation": "Automatización de la programación",
        "priorityScheduling": "Programación prioritaria",
        "alerts": "Alertas",
        "audio": "Audio",
        "videoWallSupport": "Soporte técnico de Pared de vídeo*",
        "new": "¡Noticia!",
        "withTheNew": "*Con la noticia"
    },
    "planUpgrade": {
        "errorFetchingInvoice": "Error en la captura de la factura. Vuélvalo a intentar.",
        "close": "cerrar",
        "getPremium": "Pase a Premium!",
        "companyName": "Nombre de la empresa",
        "dialogTitle": "Actualización del plan",
        "navConfirm": "Confirmar",
        "navFinish": "FINALIZAR",
        "navNext": "Siguiente",
        "navPrev": "Volver",
        "navCancel": "Cancelar",
        "VATNumber": "Número de CIF",
        "Overview": "Información general",
        "AccountOwner": "Propietario de la cuenta",
        "CompanyInfo": "Información de la empresa",
        "BillingDetails": "Información de facturación",
        "Payment": "Pago",
        "tryAgain": "VOLVER A INTENTARLO",
        "paymentSuccessful": "Pago correcto",
        "welcomeToPremium": "Le damos la bienvenida a Premium",
        "paymentFailed": "Error en el pago.",
        "selectCountry": "Seleccionar país",
        "selectState": "Seleccionar estado"
    },
    "licenseOrdering": {
        "yourOrders": "Sus pedidos",
        "cancelOrder": "CANCELAR PEDIDO",
        "orderNumber": "Número de pedido",
        "orderDate": "Fecha de pedido",
        "comment1": "Comentario 1",
        "comment2": "Comentario 2",
        "close": "CERRAR",
        "cancelOrderWarning": "¿Seguro que quiere cancelar este pedido?",
        "noOrdersAvailable": "No ha realizado ningún pedido",
        "noRecordsFound": "No se han encontrado resultados para la consulta «{query}»",
        "noRecordsFoundNote1": "Compruebe si hay errores ortográficos o de otro tipo en la búsqueda",
        "noRecordsFoundNote2": "Inténtelo con una consulta de búsqueda distinta"
    },
    "fileUpload": {
        "notAllowedToUploadMedia": "El usuario no tiene permiso para realizar una actualización en el contenido multimedia.",
        "hashMD5ComputationError": "Algo salió mal al calcular el hashMD5.",
        "duplicateFileUploadErrorTitle": "Ya existe un archivo con este nombre",
        "multipleDuplicateFileUploadErrorTitle": "Ya existen archivos con estos nombres",
        "duplicateFileUploadErrorDescription": "Ya existe un archivo llamado \"{mediaName}\" en su biblioteca.",
        "multipleDuplicateFileUploadErrorDescription": "Ya existen archivos llamados \"{mediaNames}\" en su biblioteca.",
        "duplicateFileUploadErrorMessage": "Revise el/los archivo(s) existente(s) y elija qué le gustaría hacer con su nueva carga.\n{pleaseNote}: Si reemplaza el archivo existente, vuelva a cargar la página después de que finalice la carga para ver la versión actualizada.",
        "duplicateFileUploadPreviewTitle": "Archivo(s) existente(s)",
        "pleaseNote": "Tenga en cuenta"
    },
    "downloadLicense": {
        "confirmDownloadLicense": "¿Estás seguro? Este método es exclusivo para reproductores que no estarán conectados a Internet.",
        "confirmDownloadLicenseWarning": "Usar este método asociará inmediatamente la licencia al número de serie sin período de gracia para cambios."
    },
    "activation": {
        "assign": "ASIGNAR",
        "yourLicenses": "Sus licencias",
        "comment": "Comentario",
        "playerSerialNumber": "Número de serie del reproductor",
        "licenseCode": "Código de licencia",
        "activationDate": "Fecha de activación",
        "license": "Licencia",
        "suspend": "SUSPENDER",
        "restore": "RESTAURAR",
        "download": "DESCARGAR",
        "licenseAvailable": "Licencia disponible ",
        "licenseLockedToAPlayer": "Licencia bloqueada para un reproductor",
        "playerSerialNumberRequired": "Código del número de serie del reproductor requerido",
        "licenseCodeRequired": "Código de licencia requerido",
        "processing": "Procesando",
        "waitingForPlayerToConnect": "Esperando a que se conecte el reproductor",
        "noLicensesAvailable": "No ha añadido ninguna licencia"
    },
    "resolutionCalculator": {
        "invalidPitch": "Inclinación no válida",
        "invalidSize": "Tamaño no válido"
    },
    "legal": {
        "legal": "Legal",
        "endUserLicenseAgreement": "CONTRATO DE LICENCIA DEL USUARIO FINAL",
        "generalTermsAndConditionsOfSale": "CONDICIONES GENERALES DE VENTA",
        "termsOfService": "CONDICIONES DEL SERVICIO",
        "privacyPolicy": "POLÍTICA DE PRIVACIDAD",
        "cookieNotice": "AVISO SOBRE LAS COOKIES",
        "downloadPDF": "DESCARGAR PDF"
    },
    "accountSuspended": {
        "bannerTitle": "Su suscripción ha caducado.",
        "bannerMessage": "Si quiere renovarla, póngase en contacto con su distribuidor."
    },
    "errors": {
        "invalid": {
            "verificationCode": "El código de verificación proporcionado no es válido, inténtalo de nuevo.",
            "passwordReset": "No se puede restablecer la contraseña.",
            "provider": "Proveedor no válido. Por favor, inténtalo de nuevo.",
            "emailMismatch": "La dirección de correo electrónico que ingresó no coincide con la cuenta a la que intenta migrar."
        },
        "existing": {
            "userAlreadyLinked": "El usuario ya está vinculado a un proveedor de identidad (IdP) diferente.",
            "accountInAnotherRegion": "El usuario ya tiene una cuenta en otra región"
        },
        "failedRefreshToken": "Has cerrado sesión. Inicia sesión nuevamente para continuar.",
        "cannotMigrateAccountInAnotherRegion": "No se puede migrar a SSO porque su dirección de correo electrónico está vinculada a una región de almacenamiento de datos diferente a la de la cuenta a la que intenta migrar.",
        "nonSSOAuthDenied": "No se permite la autenticación a través de un proveedor que no sea SSO.",
        "ssoMigrationFailed": "Acceso denegado: No puedes cambiar a SSO porque tu cuenta ya está vinculada a un proveedor de identidad (IdP) diferente. Por favor, contacta con tu administrador para obtener más ayuda.",
        "loginUnexpectedError": "El inicio de sesión falló debido a un error inesperado. Por favor, inténtalo de nuevo.",
        "unexpectedError": "Se ha producido un error inesperado. Por favor, recarga la página.",
        "somethingWentWrong": "Parece que algo salió mal ({errorCode})",
        "somethingWentWrongDescription": "Algo salió mal al cargar esta página.<br><br><strong>Qué puedes hacer:</strong><br>Actualiza la página e inténtalo de nuevo.<br>Si sigue sin cargar, por favor contacta al soporte y comparte el ID de solicitud que aparece a continuación.",
        "failedToUpdateAccountInfo": "No se pudo actualizar la información de la cuenta.",
        "failedToFetchLicenses": "Error al obtener las licencias.",
        "failedToDownloadLicense": "Error al descargar la licencia.",
        "failedToDownloadFile": "Error al descargar el archivo.",
        "failedToFetchUserInfo": "Error al obtener la información del usuario",
        "failedToFetchPlaces": "Error al obtener los lugares",
        "fileNotSupported": "Tipo de archivo no compatible."
    },
    "regionNames": {
        "eu": "Unión Europea / European Union",
        "ch": "Suiza / Switzerland",
        "us": "Estados Unidos / United States",
        "ca": "Canadá / Canada",
        "au": "Australia / Australia",
        "hk": "Hong Kong / Hong Kong",
        "sg": "Singapur / Singapore"
    },
    "zendesk": {
        "chatCouldNotBeLoaded": "No se pudo cargar el chat",
        "chatCouldNotBeLoadedDescription": "No pudimos cargar el chat de soporte. Esto normalmente se debe a la configuración de privacidad o de cookies de tu navegador. Para obtener instrucciones sobre cómo habilitar el chat de soporte, haz clic aquí: {url}."
    },
    "media": {
        "mediaUploadSuccessTitle": "Estamos preparando tu contenido multimedia…",
        "mediaUploadSuccessMessage": "Puede que no aparezca en la vista actual debido a filtros o clasificación activos.",
        "mediaViewLegacyToV2Title": "Páginas de medios rediseñadas",
        "mediaViewV2ToLegacyTitle": "¡Estás usando el nuevo diseño!",
        "mediaViewSwitcherDescription": "Navegación más rápida, filtros y ordenación.",
        "mediaDeleteConfirmation": "¿Estás seguro de que deseas eliminar el medio \"{mediaName}\"?",
        "multipleMediaDeleteConfirmation": "¿Seguro que quieres eliminar los {mediaCount} elementos multimedia seleccionados?",
        "mediaDeleteWarning": "Al eliminar este medio también se eliminará de todos los proyectos.",
        "multipleMediaDeleteWarning": "Al eliminar estos medios también se eliminarán de todos los proyectos que los utilicen.",
        "mediaFileUploadInfoMessage": "Si no los ve en la vista actual, pueden estar ocultos por filtros activos u ordenación.",
        "mediaIsReady": "¡Tu contenido multimedia está listo!",
        "mediaIsReadyWithCount": "¡Tu contenido multimedia está listo! ({count} de {total})",
        "someFilesUploadError": "Algunos archivos no se pudieron procesar",
        "failedUploadError": "No se pudieron procesar tus archivos. Intenta subirlos de nuevo.",
        "failedUploadErrorTitle": "No pudimos procesar tu contenido multimedia"
    },
    "led": {
        "deleteCanvasConfirmation": "¿Estás seguro? Esta acción eliminará esta resolución de lienzo de todos los reproductores.",
        "deleteCanvasWarning": "Cualquier reproductor que haya utilizado esta resolución de lienzo deberá reconfigurarse antes de que se pueda volver a publicar contenido con la misma resolución en él."
    },
    "popId": {
        "deletePopIdConfirmation": "¿Estás seguro? Esta acción eliminará este identificador PoP de todos los lugares donde se utiliza."
    },
    "tag": {
        "deleteTagConfirmation": "¿Estás seguro? Esta acción eliminará esta etiqueta de todos los {source}.",
        "deleteTagWarning": "Esto podría afectar a tus permisos de usuario y a tu programación."
    },
    "leaveAccount": {
        "leaveAccountConfirmation": "¿Estás seguro de que quieres abandonar la cuenta [{accountName}]?",
        "leaveAccountWarning": "Al abandonar esta cuenta, perderás el acceso a la cuenta y a todos los productos y servicios asociados disponibles actualmente."
    },
    "userProfile": {
        "permanent": "permanente",
        "deleteUserConfirmation": "Estás a punto de eliminar tu perfil de usuario. Esta acción es {permanent} y no se puede deshacer.",
        "lose": "perder",
        "deleteUserWarning": "Al continuar, {lose} el acceso a todas las cuentas y productos asociados a tus credenciales.\n¿Seguro que quieres continuar?"
    }
}
